/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Container, Row, Button, Col } from "react-bootstrap";
import "./Contactus.css";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import axios from "axios";
import Staff from "../staff/staff.js";
import { capitalizeFirstLetter } from "../Utils/index.js";

export default function Contactus({ realtorData, loanOfficerActive, loanOfficerData, angelAiUserInfo }) {
  const [showFormModal, setShowFormModal] = useState(false);
  const [loanPurposeKwd, setLoanPurposeKwd] = useState("");
  const [frmHeading, setFrmHeading] = useState("");
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();
  const realtorName = realtorData ? capitalizeFirstLetter(realtorData.name) : "";
  let loanOfficerName;
  if (loanOfficerActive) {
    loanOfficerName = loanOfficerData ? capitalizeFirstLetter(loanOfficerData.name) : "";
  } else {
    loanOfficerName = angelAiUserInfo ? capitalizeFirstLetter(angelAiUserInfo.angelAIBrandingInfo.brandName) : "";
  }
  useEffect(() => {
    /**
     * @author Pratik Kajrolkar
     * @date 07/17/2023
     * The below function is used to fetch the swmc footer data which
     * is stored in master JSON in S3 bucket.
     * @returns JSON Object of the requested file
     */
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []);
  const handleButtonClick = () => {
    // Replace 'https://example.com' with the URL you want to open.
    window.open("https://www.swmc.com/ApplyNow/?lof=P590", "_blank");
  };
  const handleApplyNowModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now");
  };
  const [node, setNode] = useState(null);
  const formRef = useCallback((node) => {
    // node refers to the name input field in the BorrowerLeadGenerationTool
    setNode(node);
  }, []);
  const handleCloseFormModal = () => setShowFormModal(false);
  return (
    <>
      <Container >
        <div className="contactuscontainer">
          <Row>
            <p className="comprehensivetext">Mastering Asset Leverage with {realtorName} and {loanOfficerName}</p>
            {/* <hr className="hrline" /> */}
            <p className="yourjournytext">Unlocking the true value of your assets demands both knowledge and a well-devised strategy. {realtorName} and {loanOfficerName} stand at the forefront of this domain, offering you a unique opportunity to grasp the nuances of asset leverage. Delve deep into potent strategies, gain invaluable insights into current market trends, and understand the art of amplifying returns on your investments.<br /><br />
              In the intricate landscape of property investment, having seasoned mentors can be transformational. {loanOfficerName} and {realtorName} are dedicated to lighting up your investment journey. Reach out to them for personalized advice, loan applications, or any real estate consultation. They're committed to ensuring your success.</p>
          </Row>
        </div>
        <div className="staffrow" id="staffId">
          <Staff
            realtorData={realtorData}
            loanOfficerActive={loanOfficerActive}
            loanOfficerData={loanOfficerData}
            angelAiUserInfo={angelAiUserInfo}
          />
        </div>

        {/* <Row className="applycol" sm={12} md={12} xl={12} xxl={12} lg={12}>
          <div className="applybtn text-center mb-3">
            <Button
              variant="primary"
              className="applyNowBtn"
              onClick={handleButtonClick}
            >
              Apply Now
            </Button>
          </div>
        </Row> */}

        <div className="borrtoolrow mb-3">
          <Col className="borrleadtoolcol" sm={12} md={12} xl={12} xxl={12} lg={12}>
            <div className="request">
              <h5>Request a Callback</h5>
            </div>
            <BorrowerLeadGenerationTool
              leadSource="Self"
              branch=""
              showModalBackBtn={false}
              // statesDomain={process.env.REACT_APP_STATE_DOMAIN}
              ref={formRef}
              loanOfficerUid={loanOfficerData.ssid}
              mainBtnName="Call Me"
            />
          </Col>
        </div>
      </Container>
      <Container>
        <Row className="lastpara pb-3">
          <p> *Visit{" "}
            <a
              href="https://www.swmc.com/tru-terms"
              target="_blank"
              rel="noreferrer noopener"
              aria-label="swmc-tru-terms"
              className="swmc-tru-terms"
            >
              swmc.com/tru-terms
            </a>{" "}
            for TRU Approval® terms and conditions.<br />
            For all these programs, Sun West is acting as a broker.<br />
            Being High Risk Loans, DSCR, Bridge, Fix and Flip, and Commercial Construction Loans may include higher interest rates, closing costs, interest-only periods, or prepayment penalties.<br />
            Interest-only mortgages allow you to pay only the interest on the money you borrow for the first few years of the mortgage (the "interest-only period"). If you make interest-only payments, then at the end of the interest-only period you will still owe the original amount you borrowed and your monthly payment will increase because you must pay back the principal as well as interest. Your payments could increase even more if you have an Adjustable Rate Mortgage (ARM) and interest rate increase.<br />
            Realtor® is a registered trademark of National Association of Realtors®.<br />
          </p>
        </Row>
      </Container>

    </>
  );
}
